import Loading from '@/components/elements/loading';
import Attachment from '@/components/elements/attachment';
import EmptyState from '@/components/elements/empty-state';
import AppTooltip from '@/components/elements/tooltip';
import IdentifierBadge from '@/components/elements/identifier-badge';

import InputSwitch from '@/components/forms/input-switch';
import ImageInput from '@/components/forms/image-input';
import InputSelect from '@/components/forms/input-select';
import InputColor from '@/components/forms/input-color';
import InputWysiwyg from '@/components/forms/input-wysiwyg';
import ListFooterPagination from '@/components/base/list-footer-pagination';
import AppPanel from '@/components/base/app-panel';

export default function registerGlobalComponents(app) {
    app.component('loading', Loading);
    app.component('attachment', Attachment);
    app.component('empty-state', EmptyState);
    app.component('app-tooltip', AppTooltip);
    app.component('identifier-badge', IdentifierBadge);

    app.component('input-switch', InputSwitch);
    app.component('image-input', ImageInput);
    app.component('input-select', InputSelect);
    app.component('input-color', InputColor);
    app.component('input-wysiwyg', InputWysiwyg);
    app.component('list-footer-pagination', ListFooterPagination);
    app.component('app-panel', AppPanel);
}
